import i18next from 'i18next'

export enum PaymentMethodType {
    card = 'card',
    paypal = 'paypal',
    applepay = 'applepay',
    googlepay = 'googlepay',
    openbanking = 'openbanking',
    paybybankapp = 'payByBankApp',
    bankpayout = 'bankpayout',
    klarna = 'klarna',
    clicktopay = 'clicktopay',
    astropay = 'astropay',
    alipay = 'alipay',
    wechatpay = 'wechatpay'
}

export const getPaymentMethodTypeLabel = (paymentMethod: PaymentMethodType) => {
    return i18next.t(`enums:paymentMethodType.${paymentMethod}`, {defaultValue: paymentMethod})
}
